import { Navigate } from 'react-router-dom';
import { getDashboardBase } from '../utils/dashboardRoutes';

// Wraps public-only routes (e.g. login). If the user already has a valid
// token, redirect them straight to their dashboard instead of showing login.
const GuestRoute = ({ children }) => {
    const token = localStorage.getItem('access_token');
    if (token) {
        const expiry = localStorage.getItem('token_expiry');
        if (expiry && new Date() < new Date(expiry)) {
            const dashboard = getDashboardBase();
            if (dashboard) return <Navigate to={dashboard} replace />;
        }
    }
    return children;
};

export default GuestRoute;
